import React, {FC} from 'react';
import {Box, Dialog} from "@scope/scope-one-ui/core";
import {ButtonVariant} from "@scope/scope-one-ui/core/Button/Button.d";


type ConfirmModalProps = {
  title: string;
  text: string;
  confirmLabel: string;
  onClose: (set: boolean) => void;
  onConfirm: () => void;
  open: boolean;
  variant?: ButtonVariant;
};

export const ConfirmModal: FC<ConfirmModalProps> = ({open, title, text, confirmLabel, onClose, onConfirm, variant}) => {
  return (
    <Dialog variant={variant} open={open} onClose={() => onClose(false)} title={title} confirmLabel={confirmLabel}
            onConfirm={onConfirm}>
      <Box p={3}>
        {text}
      </Box>
    </Dialog>
  );
};
